import React from 'react';
import { TeamMembers } from './TeamMembers';
import { InsightCard } from './InsightCard';
import { ActionItem } from './ActionItem';
import { WorkspaceMetrics } from './WorkspaceMetrics';
import { CommentThread } from './CommentThread';
import { UsersIcon, BarChart3Icon, CalendarIcon, FilterIcon } from 'lucide-react';
export const WorkspaceHub = () => {
  // Sample data for demonstration
  const insights = [{
    id: 1,
    title: 'Customer Satisfaction Trend Q2',
    description: 'Analysis of customer satisfaction scores showing 12% improvement after new feature launch',
    author: 'Emma Thompson',
    team: 'CX',
    date: '2 days ago',
    comments: 8,
    actions: 3,
    priority: 'high'
  }, {
    id: 2,
    title: 'User Onboarding Friction Points',
    description: 'Research identified 3 key friction points in the onboarding flow affecting conversion',
    author: 'Michael Chen',
    team: 'Research',
    date: 'Yesterday',
    comments: 12,
    actions: 5,
    priority: 'medium'
  }, {
    id: 3,
    title: 'Product Usage Analytics',
    description: 'Dashboard feature usage increased by 24% after UI improvements',
    author: 'Sarah Johnson',
    team: 'Product',
    date: '4 hours ago',
    comments: 3,
    actions: 2,
    priority: 'low'
  }];
  const actions = [{
    id: 1,
    title: 'Update onboarding flow based on research findings',
    assignee: 'David Wilson',
    team: 'Product',
    dueDate: 'Jul 28',
    status: 'in-progress',
    priority: 'high'
  }, {
    id: 2,
    title: 'Create presentation for executive review',
    assignee: 'Lisa Brown',
    team: 'Marketing',
    dueDate: 'Jul 30',
    status: 'not-started',
    priority: 'medium'
  }, {
    id: 3,
    title: 'Implement customer feedback collection point',
    assignee: 'James Taylor',
    team: 'CX',
    dueDate: 'Aug 5',
    status: 'completed',
    priority: 'medium'
  }];
  return <div className="space-y-6" data-id="element-111">
      <div className="flex items-center justify-between" data-id="element-112">
        <div data-id="element-113">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-114">
            Insight Workspaces
          </h1>
          <p className="text-gray-500" data-id="element-115">
            Collaborate on customer insights and actions
          </p>
        </div>
        <div className="flex items-center gap-4" data-id="element-116">
          <TeamMembers data-id="element-117" />
          <div className="flex items-center gap-2" data-id="element-118">
            <span className="text-sm text-gray-500" data-id="element-119">
              Last updated: 10 minutes ago
            </span>
            <button className="text-blue-600 text-sm font-medium" data-id="element-120">Share</button>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-6" data-id="element-121">
        <WorkspaceMetrics data-id="element-122" />
      </div>
      <div className="flex items-center justify-between" data-id="element-123">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-124">Recent Insights</h2>
        <div className="flex items-center gap-3" data-id="element-125">
          <div className="flex items-center gap-2" data-id="element-126">
            <FilterIcon size={16} className="text-gray-500" data-id="element-127" />
            <select className="text-sm border border-gray-300 rounded-md px-2 py-1" data-id="element-128">
              <option data-id="element-129">All Teams</option>
              <option data-id="element-130">CX</option>
              <option data-id="element-131">Research</option>
              <option data-id="element-132">Marketing</option>
              <option data-id="element-133">Product</option>
            </select>
          </div>
          <button className="text-blue-600 text-sm font-medium" data-id="element-134">
            View All
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-135">
        {insights.map(insight => <InsightCard key={insight.id} insight={insight} data-id="element-136" />)}
      </div>
      <div className="flex items-center justify-between mt-8" data-id="element-137">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-138">Action Items</h2>
        <div className="flex items-center gap-3" data-id="element-139">
          <div className="flex items-center gap-2" data-id="element-140">
            <FilterIcon size={16} className="text-gray-500" data-id="element-141" />
            <select className="text-sm border border-gray-300 rounded-md px-2 py-1" data-id="element-142">
              <option data-id="element-143">All Status</option>
              <option data-id="element-144">Not Started</option>
              <option data-id="element-145">In Progress</option>
              <option data-id="element-146">Completed</option>
            </select>
          </div>
          <button className="text-blue-600 text-sm font-medium" data-id="element-147">
            View All
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-148">
        {actions.map(action => <ActionItem key={action.id} action={action} data-id="element-149" />)}
      </div>
      <div className="mt-8" data-id="element-150">
        <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-151">
          Recent Discussions
        </h2>
        <CommentThread data-id="element-152" />
      </div>
    </div>;
};